module.exports = __webpack_public_path__ + "img/bladeren_low.4198ea15.png";